var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"emoji",attrs:{"draggable":"false","alt":_vm.emoji,"src":_vm.emojiUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }